/**
 * Opening a run output the holding host keeps (PLAN-20260901 slice 11 unit
 * B3), here a form question's evidence (agion/Agion#3437 C6). The streaming
 * service reads the run again as this viewer and asks the holding host for
 * the text. It answers 404 reference_unavailable when the output cannot be
 * opened (the run's content is not open to the viewer among the causes) and
 * 413 reference_too_large when the host keeps it but cannot send it in one
 * frame; each rejects as the API client's ChatApiError. admin-ui's
 * services/run-output-open.ts is the same call in its own client.
 */

import { apiClient } from './api'
import { isChatApiError } from './api-failure'
import type { EvidenceRef } from './escalation-form'

/** Why an open did not return the output. */
export type RunOutputOpenRefusal = 'unavailable' | 'too_large' | 'failed'

/** Opens a run output and resolves with its text, whole. */
export async function openRunOutput(ref: EvidenceRef): Promise<string> {
  const opened = await apiClient.post<{ content?: unknown }>('/v1/streaming/run-output/open', ref)
  if (typeof opened?.content !== 'string') throw new Error('The run output answer has no content')
  return opened.content
}

/** The refusal an open failed with, from the server's code. */
export function runOutputOpenRefusalOf(error: unknown): RunOutputOpenRefusal {
  if (!isChatApiError(error)) return 'failed'
  switch (error.code) {
    case 'reference_unavailable':
      return 'unavailable'
    case 'reference_too_large':
      return 'too_large'
    default:
      return 'failed'
  }
}

type Translate = (key: string, fallback: string) => string

/** What a refused evidence open says, in both Escalations sections. */
export function evidenceRefusalText(refusal: RunOutputOpenRefusal, t: Translate): string {
  switch (refusal) {
    case 'unavailable':
      return t('escalations.evidence.error.unavailable', 'The evidence cannot be opened.')
    case 'too_large':
      return t('escalations.evidence.error.tooLarge', 'The evidence is too large to open here.')
    default:
      return t('escalations.evidence.error.failed', 'The evidence did not open. Try again.')
  }
}
